export default class UnexpectedErrorResponseError extends Error {}
